export default __webpack_public_path__ + "static/media/graphic-02.8910c9e1.png";